import anime from 'animejs/lib/anime.es.js';
import { delay } from 'rxjs';

export const animateInputAssist = () => {
    setTimeout(() => {
        anime({
            targets: '#input-assist',
            duration: 1300,
            opacity: [0, 1],
            easing: 'easeInOutSine',
        });
        anime({
            targets: '.left-arrow',
            duration: 800,
            scale: [1, 1.4, 1],
            rotate: [-90, 90],
            delay: 800,
            easing: 'easeInOutSine',
        });
        anime({
            targets: '.right-arrow',
            duration: 800,
            scale: [1, 1.4, 1],
            rotate: [90, -90],
            delay: 800,
            easing: 'easeInOutSine',
        });
    }, 100);
}